export default __webpack_public_path__ + "static/media/DavidPetkovskiMobile.40224419.png";